import type { ComponentType } from 'react'
import { AutumnRoofLoad } from './Autumn'
import { ChristmasRoofLoad } from './Christmas'
import { createEasterScenery, EasterRoofLoad } from './Easter'
import { seasonColors } from './shared'
import { SpringRoofLoad } from './Spring'
import { SinterklaasRoofLoad } from './Sinterklaas'
import { SummerRoofLoad } from './Summer'

export const festives = ['default', 'spring', 'summer', 'autumn', 'sinterklaas', 'christmas', 'easter'] as const

export type Festive = (typeof festives)[number]

export type Foreground = {
  shape: 'snowflake' | 'leaf' | 'petal'
  colors: string[]
  edgeColor: string
  size: number
  columns: number
  rows: number
  fallSpeed: number
  sway: number
}

export type SeasonLook = {
  roofLoad: ComponentType | null
  foreground: Foreground | null
  background?: string
}

export const festiveLooks: Record<Festive, SeasonLook> = {
  default: { roofLoad: null, foreground: null },
  spring: {
    roofLoad: SpringRoofLoad,
    foreground: {
      shape: 'petal',
      colors: [seasonColors.blossom, seasonColors.pink],
      edgeColor: 'none',
      size: 3.2,
      columns: 5,
      rows: 3,
      fallSpeed: 30,
      sway: 9,
    },
  },
  summer: { roofLoad: SummerRoofLoad, foreground: null },
  autumn: {
    roofLoad: AutumnRoofLoad,
    foreground: {
      shape: 'leaf',
      colors: [seasonColors.orange, seasonColors.rust, seasonColors.ochre],
      edgeColor: 'none',
      size: 5.5,
      columns: 4,
      rows: 3,
      fallSpeed: 34,
      sway: 12,
    },
  },
  sinterklaas: { roofLoad: SinterklaasRoofLoad, foreground: null },
  christmas: {
    roofLoad: ChristmasRoofLoad,
    foreground: {
      shape: 'snowflake',
      colors: [seasonColors.snow],
      edgeColor: seasonColors.snowEdge,
      size: 2.6,
      columns: 6,
      rows: 4,
      fallSpeed: 38,
      sway: 6,
    },
  },
  easter: {
    roofLoad: EasterRoofLoad,
    background: createEasterScenery(),
    foreground: null,
  },
}
